module.exports = __webpack_public_path__ + "img/cloud_seagate.48d865e8.png";